<template>
    <el-dialog title="选择栏目" :visible="visible" @update:visible="$emit('update:visible', $event)" @open="onDialogOpen" :before-close="onBeforeClose">
        <el-form v-if="addSectionModel" ref="addSectionForm" :model="addSectionModel" label-width="120px"
                 :rules="addSectionRules">
            <el-form-item label="栏目来源" prop="sectionSource">
                <el-select v-model="addSectionModel.sectionSource" @change="onSectionSourceChanged">
                    <el-option value="create" label="创建新栏目"></el-option>
                    <el-option v-if="enablePlaceholderSection" value="placeholder" label="创建占位栏目"></el-option>
                    <el-option value="existed" label="从已有栏目中选择"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="栏目名称" prop="name" v-if="addSectionModel.sectionSource !== 'existed'">
                <el-input v-model="addSectionModel.name"></el-input>
            </el-form-item>
            <el-form-item label="栏目类型" prop="type" v-if="addSectionModel.sectionSource !== 'existed'">
                <el-select v-model="addSectionModel.type">
                    <el-option v-for="type in sectionTypes" :key="type.type" :value="type.type"
                               :label="type.typeName"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="选择栏目" prop="id" v-if="addSectionModel.sectionSource === 'existed'">
                <el-select v-model="addSectionModel.section" value-key="id">
                    <el-option v-for="section in sections" :key="section.id" :value="section"
                               :label="section.name"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="onCancel">取 消</el-button>
            <el-button type="primary" @click="onAddSectionFormSubmit">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import sectionService from '../../service/section'
    import sectionTypeService from '../../service/section-type'

    export default {
        name: "SectionSelect",
        props: ['visible', 'enablePlaceholderSection', 'onSelect'],
        data() {
            return {
                addSectionModel: {
                    sectionSource: 'create',
                    name: null,
                    type: null,
                    section: null
                },
                addSectionRules: null,
                addSectionRules1: {
                    sectionSource: [
                        {required: true, message: '请选择栏目来源', trigger: 'blur'}
                    ],
                    name: [
                        {required: true, message: '请输入栏目名称', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                    ],
                    type: [
                        {required: true, message: '请选择栏目类型', trigger: 'blur'}
                    ]
                },
                addSectionRules2: {
                    sectionSource: [
                        {required: true, message: '请选择栏目来源', trigger: 'blur'}
                    ],
                    section: [
                        {required: true, message: '请选择栏目', trigger: 'blur'}
                    ]
                },
                sectionTypes: [],
                sections: []
            }
        },
        created(){
            this.init()
        },
        methods: {
            init(){
                sectionTypeService.getAssignedSectionTypes().then(sectionTypes => this.sectionTypes=sectionTypes)
            },
            onDialogOpen() {
                sectionService.listSections({page: 0, size: 100}).then(response => {
                    this.sections = response.data.content
                })
            },
            onBeforeClose(done){
                done()
                this.onSelect(null)
            },
            onCancel(){
                this.$emit('update:visible', false)
                this.onSelect(null)
            },
            onSectionSourceChanged() {
                if (this.addSectionModel.sectionSource !== 'existed') {
                    this.addSectionRules = this.addSectionRules1
                } else {
                    this.addSectionRules = this.addSectionRules2
                }
            },
            onAddSectionFormSubmit() {
                this.$refs.addSectionForm.validate().then(() => {
                    if (this.addSectionModel.sectionSource === 'create') {
                        const section = {
                            name: this.addSectionModel.name,
                            type: this.addSectionModel.type
                        }
                        sectionService.addSection(section).then((response) => {
                            this.$message({
                                type: 'success',
                                message: '创建栏目成功!'
                            })
                            section.id = response.data.id
                            this.onSelect(section)
                        }).catch(() => {
                            this.$message({
                                type: 'error',
                                message: '创建新栏目失败!'
                            })
                        })
                    } else if (this.addSectionModel.sectionSource === 'placeholder') {
                        const section = {
                            name: this.addSectionModel.name,
                            type: this.addSectionModel.type
                        }
                        this.onSelect(section)
                    } else {
                        this.onSelect(this.addSectionModel.section)
                    }
                    this.$emit('update:visible', false)
                }).catch(() => {
                })
            }
        }
    }
</script>

<style scoped>

</style>
